module.exports = __webpack_public_path__ + "img/verification-code.8ff97bfe.svg";